import { gql } from '@apollo/client';

export interface InviteClinicAdminInput {
  email: string;
  clinicId?: string;
  nameFirst?: string;
  nameLast?: string;
  roleName: string;
}

export const INVITE_CLINIC_ADMIN = gql`
  mutation inviteClinicAdmin($input: InviteClinicAdminInput!) {
    inviteClinicAdmin(input: $input) {
      id
      email
      nameFirst
      nameLast
      type
    }
  }
`;
